import { render, staticRenderFns } from "./ShippingCompanyTable.vue?vue&type=template&id=2ecce739&scoped=true"
import script from "./ShippingCompanyTable.vue?vue&type=script&lang=js"
export * from "./ShippingCompanyTable.vue?vue&type=script&lang=js"
import style0 from "./ShippingCompanyTable.vue?vue&type=style&index=0&id=2ecce739&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecce739",
  null
  
)

export default component.exports